import React from "react";
import { renderRoutes } from "react-router-config";
import PropTypes from "prop-types";
import moment from "moment";
import "moment/locale/fr";
import { MuiThemeProvider } from "material-ui/styles";
import CssBaseline from "material-ui/CssBaseline";
// eslint-disable-next-line
import "typeface-nunito";

import theme from "../styles/theme";

import "../styles/global.scss";

moment.locale("fr");

const App = ({ route }) => (
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    {renderRoutes(route.routes)}
  </MuiThemeProvider>
);

App.propTypes = {
  route: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/app/App.jsx